import { useTranslation } from 'react-i18next';

export enum PatientValidationErrorCode {
  FIRST_NAME_REQUIRED = 'FIRST_NAME_REQUIRED',
  LAST_NAME_REQUIRED = 'LAST_NAME_REQUIRED',
  DATE_OF_BIRTH_REQUIRED = 'DATE_OF_BIRTH_REQUIRED',
  PHONE_REQUIRED = 'PHONE_REQUIRED',
  INVALID_EMAIL_FORMAT = 'INVALID_EMAIL_FORMAT',
  INVALID_PHONE_FORMAT = 'INVALID_PHONE_FORMAT',
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  INVALID_GENDER = 'INVALID_GENDER',
  INVALID_NIF = 'INVALID_NIF',
  INVALID_SOCIAL_SECURITY_NUMBER = 'INVALID_SOCIAL_SECURITY_NUMBER',
}

export const usePatientErrorValidation = () => {
  const { t } = useTranslation();

  const patientErrorsList = {
    [PatientValidationErrorCode.FIRST_NAME_REQUIRED]: t(
      'patient_import_errors.field_is_required',
    ),
    [PatientValidationErrorCode.LAST_NAME_REQUIRED]: t(
      'patient_import_errors.field_is_required',
    ),
    [PatientValidationErrorCode.DATE_OF_BIRTH_REQUIRED]: t(
      'patient_import_errors.field_is_required',
    ),
    [PatientValidationErrorCode.PHONE_REQUIRED]: t(
      'patient_import_errors.field_is_required',
    ),
    [PatientValidationErrorCode.INVALID_EMAIL_FORMAT]: t(
      'patient_import_errors.email_must_be_valid',
    ),
    [PatientValidationErrorCode.INVALID_PHONE_FORMAT]: t(
      'patient_import_errors.is_not_valid',
    ),
    [PatientValidationErrorCode.INVALID_DATE_FORMAT]: t(
      'patient_import_errors.invalid_date_format',
    ),
    [PatientValidationErrorCode.INVALID_GENDER]: t(
      'patient_import_errors.invalid_gender',
    ),
    [PatientValidationErrorCode.INVALID_NIF]: t(
      'patient_import_errors.format_is_incorrect',
    ),
    [PatientValidationErrorCode.INVALID_SOCIAL_SECURITY_NUMBER]: t(
      'patient_import_errors.invalid_ssn',
    ),
  };

  return { patientErrorsList };
};
